/* eslint-disable @next/next/no-img-element */
import React from 'react'

import styles from './styles.module.scss'
import BankOfIreland from '../../public/assets/icons/bank-of-ireland-text.svg'

interface IPoweredByText {
  text?: string;
  className?: string;
  textClassName?: string;
}

export default function PoweredByText({ text = 'LeasePlan', className, textClassName }: IPoweredByText) {
  return (
    <p className={`${styles.poweredBy} ${className}`}>
      Powered by { text === 'Bank of Ireland' ? <img className={styles.logo} src={BankOfIreland.src} alt={text} /> : <span className={`${styles.orange} ${textClassName}`}>{ text }</span> } 
    </p>
  )
}